class MemoryStorage implements Pick<Storage, 'getItem' | 'setItem' | 'removeItem' | 'clear'> {
  private _data: Record<string, string> = {};

  getItem(key: string): string | null {
    return Object.prototype.hasOwnProperty.call(this._data, key) ? this._data[key] : null;
  }

  setItem(key: string, value: string): void {
    this._data[key] = String(value);
  }

  removeItem(key: string): void {
    delete this._data[key];
  }

  clear(): void {
    this._data = {};
  }
}

function isLocalStorageAvailable(): boolean {
  try {
    let key = '__storage_test__';
    localStorage.setItem(key, '1');
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export let browserStorageSafe: Pick<Storage, 'getItem' | 'setItem' | 'removeItem' | 'clear'> =
  typeof window !== 'undefined' && isLocalStorageAvailable()
    ? window.localStorage
    : new MemoryStorage();
